import PageContainerBlank from '../../components/PageContainer/PageContainerBlank';
import PageEndBlank from '../../components/PageContainer/PageEndBlank';
import { useEffect, useState } from 'react';
import './LitCal.css';

const colorMap = new Map([
	['white',  '#cf8b21'], // Apr 21, 2025
	['green',  '#006847'], // Mar 2, 2025
	['red',    '#b22222'], // Apr 18, 2025
	['purple', '#572a6f'], // Mar 18, 2025
	['pink',   '#d477b3'], // Mar 30, 2025
	['rose',   '#d477b3'], // Mar 30, 2025
]);

function findToday(events = [], today) {
	return events.find(event => event.month === today.getMonth() + 1 && event.day === today.getDate());
}

function getDayColor(day) {
	return colorMap.get(day?.color?.[0]) || 'var(--header-bg)';
}

function normalizeReading(reading) {
	if (typeof reading !== 'string') return null;
	const normalizedReading = reading.trim();
	return normalizedReading && !/^\|+$/.test(normalizedReading) ? normalizedReading : null;
}

const LiturgicalDay = ({ day }) => {
	const readings = [
		['First Reading', normalizeReading(day.readings?.first_reading)],
		['Responsorial Psalm', normalizeReading(day.readings?.responsorial_psalm)],
		['Second Reading', normalizeReading(day.readings?.second_reading)],
		['Gospel Acclamation', normalizeReading(day.readings?.gospel_acclamation)],
		['Gospel', normalizeReading(day.readings?.gospel)],
	].filter(([, reading]) => reading);

	return (
		<div>
			<div className="litcal-day__header">
				<div>
					<p className="litcal-day__date">{day.day_of_the_week_long}, {day.month_long} {day.day}</p>
					<h2>{day.name}</h2>
				</div>
				<span className="litcal-day__grade">{day.grade_lcl}</span>
			</div>
			<div className="litcal-day__details">
				<p>
					<strong>{day.liturgical_season_lcl}</strong>
					{day.liturgical_year && <> · {day.liturgical_year}</>}
				</p>
				{readings.length > 0 && (
					<dl>
						{readings.map(([label, reading]) => <div key={label}><dt>{label}</dt><dd>{reading}</dd></div>)}
					</dl>
				)}
			</div>
		</div>
	);
};

const LitCal = () => {
	const [liturgicalDay, setLiturgicalDay] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		const today = new Date();
		// today.setDate(today.getDate());
		const year = today.getFullYear();
		const cached = localStorage.getItem('litcaljson');
		let cachedData = null;

		try {
			cachedData = cached ? JSON.parse(cached) : null;
		} catch {
			localStorage.removeItem('litcaljson');
		}

		const cachedYear = cachedData?.settings?.year ?? cachedData?.litcal?.[0]?.year;
		if (cachedData && cachedYear === year) {
			const todayData = findToday(cachedData.litcal, today)
			console.log('todayData: ', todayData);
			setLiturgicalDay(todayData);
			return;
		}

		const requestString = `https://litcal.johnromanodorazio.com/api/dev/calendar/${year}?locale=en&epiphany=SUNDAY_JAN2_JAN8&ascension=THURSDAY&corpus_christi=SUNDAY&eternal_high_priest=false&year_type=CIVIL&return_type=JSON`;
		fetch(requestString)
			.then(response => {
				if (!response.ok) throw new Error('Unable to load the liturgical calendar.');
				return response.json();
			})
			.then(data => {
				localStorage.setItem('litcaljson', JSON.stringify(data));
				const todayData = findToday(data.litcal, today)
				console.log('todayData: ', todayData);
				setLiturgicalDay(todayData);
			})
			.catch(fetchError => setError(fetchError.message));
	}, []);

	return (
		<div>
			<PageContainerBlank />

			<h1>Today's Liturgical Day</h1>

			<div id="visualized-day"
					className={`litcal-day${liturgicalDay ? ' litcal-day--ready' : ''}`}
					style={{ '--litcal-color': getDayColor(liturgicalDay) }}>
				{error && <p className="litcal-status">{error}</p>}
				{!error && !liturgicalDay && <p className="litcal-status">Loading today's calendar...</p>}
				{liturgicalDay && <LiturgicalDay day={liturgicalDay} />}
			</div>

			<PageEndBlank />
		</div>
	);
};

export default LitCal;